'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AddReaction = require('../../Reactions/AddReaction');

var _AddReaction2 = _interopRequireDefault(_AddReaction);

var _FormattedReactionCount = require('../../Reactions/FormattedReactionCount');

var _FormattedReactionCount2 = _interopRequireDefault(_FormattedReactionCount);

var _FormattedTimeAgo = require('../../shared/FormattedTimeAgo');

var _FormattedTimeAgo2 = _interopRequireDefault(_FormattedTimeAgo);

var _FormattedViews = require('../../shared/FormattedViews');

var _FormattedViews2 = _interopRequireDefault(_FormattedViews);

var _ShareButton = require('../../Sharing/ShareButton');

var _ShareButton2 = _interopRequireDefault(_ShareButton);

var _FollowUserButton = require('../../FollowUserButton');

var _FollowUserButton2 = _interopRequireDefault(_FollowUserButton);

var _Tags = require('../../Tags');

var _Tags2 = _interopRequireDefault(_Tags);

var _communityContentPlayers = require('../../../shared/logging/community-content-players');

var _communityContentPlayers2 = _interopRequireDefault(_communityContentPlayers);

var _constants = require('../../../shared/constants');

var _feedUserUtil = require('../../../utils/feed-user-util');

var _feedUserUtil2 = _interopRequireDefault(_feedUserUtil);

var _feedUserType = require('../../../shared/feed-user-type');

var _feedUserType2 = _interopRequireDefault(_feedUserType);

var _urls = require('../../../utils/urls');

var _urls2 = _interopRequireDefault(_urls);

var _Uniform = require('../../Uniform');

require('./theatre-footer.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var bullet = '' + String.fromCharCode(160) + String.fromCharCode(8226) + String.fromCharCode(160);

var TheatreFooter = function (_Component) {
  _inherits(TheatreFooter, _Component);

  function TheatreFooter() {
    _classCallCheck(this, TheatreFooter);

    return _possibleConstructorReturn(this, (TheatreFooter.__proto__ || Object.getPrototypeOf(TheatreFooter)).apply(this, arguments));
  }

  _createClass(TheatreFooter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentUserId = _props.currentUserId,
          logData = _props.logData,
          showSharing = _props.showSharing,
          video = _props.video;

      var authorId = video.ownerId;
      var author = video.ownerDetails || {};
      var profileUrl = _urls2.default.getFeedUserProfileUrl(authorId.type, authorId.relatedId);
      var isLoggedIn = currentUserId && currentUserId !== _constants.ANONYMOUS_USER_ID;
      var initials = _feedUserUtil2.default.getFeedUserInitials(author.name);
      var profilePictureUrl = author.profilePictureUrl && author.profilePictureUrl.indexOf('thumb-user.svg') === -1 ? author.profilePictureUrl : null;

      var addReactionButton = void 0;
      if (isLoggedIn) {
        addReactionButton = _react2.default.createElement(_AddReaction2.default, {
          communityContentIdObject: video.communityContentId,
          label: 'React',
          logData: _extends({}, logData, { player: _communityContentPlayers2.default.Immersive }),
          size: 'small'
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'theatre-footer uni-env--dark' },
        _react2.default.createElement(
          'div',
          { className: 'theatre-footer__row theatre-footer__row--bordered' },
          _react2.default.createElement(
            'div',
            { className: 'theatre-footer__left theatre-footer__metadata' },
            _react2.default.createElement(_FormattedTimeAgo2.default, { className: 'uni-text--small', time: video.dateCreated }),
            bullet,
            _react2.default.createElement(_FormattedViews2.default, { className: 'uni-text--small', views: video.views }),
            bullet,
            _react2.default.createElement(_FormattedReactionCount2.default, { className: 'uni-text--small', communityContentId: video.communityContentId })
          ),
          _react2.default.createElement(
            'div',
            { className: 'theatre-footer__right theatre-footer__video-buttons' },
            addReactionButton,
            _react2.default.createElement(_ShareButton2.default, { onClick: showSharing, size: 'small', style: 'minimal' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'theatre-footer__row' },
          _react2.default.createElement(
            'h3',
            { className: 'uni-headline--3 theatre-footer__left theatre-footer__video-title' },
            video.title
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'theatre-footer__row' },
          _react2.default.createElement(
            'div',
            { className: 'theatre-footer__row theatre-footer__author-container' },
            _react2.default.createElement(
              'a',
              { href: profileUrl, target: '_blank', className: 'theatre-footer__author' },
              (authorId.type === _feedUserType2.default.Hudl || authorId.type === _feedUserType2.default.Unknown) && _react2.default.createElement(_Uniform.AvatarOrg, { size: 'large', imageUrl: profilePictureUrl, initials: initials }),
              authorId.type === _feedUserType2.default.Team && _react2.default.createElement(_Uniform.AvatarTeam, { size: 'large', imageUrl: profilePictureUrl }),
              authorId.type === _feedUserType2.default.User && _react2.default.createElement(_Uniform.AvatarUser, { size: 'large', imageUrl: profilePictureUrl, initials: initials })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'theatre-footer__author-info' },
            _react2.default.createElement(
              'div',
              { className: 'theatre-footer__author-name' },
              author.name,
              _react2.default.createElement(_Tags2.default, { communityContentIdObject: video.communityContentId, taggedUsersModalEnabled: false })
            ),
            isLoggedIn && authorId && _react2.default.createElement(
              'div',
              { className: 'theatre-footer__follow-user' },
              _react2.default.createElement(_FollowUserButton2.default, { feedUserId: authorId, logData: logData })
            )
          )
        )
      );
    }
  }]);

  return TheatreFooter;
}(_react.Component);

TheatreFooter.propTypes = {
  currentUserId: _react.PropTypes.string,
  logData: _react.PropTypes.object,
  showSharing: _react.PropTypes.func.isRequired,
  video: _react.PropTypes.object
};
exports.default = TheatreFooter;